import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Typography } from '@mui/material';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { getDeliveryTimeInMinutesLabel } from '../../../../../../backend/features/alerts/utils/mapToApiSaveAlertRequest';
import { useAlertUiTranslation } from '../../../../../hooks';
import { CollapsableSection } from './CollapsableSection';
export const AlertPhinDetails = ({ data }) => {
    const { t } = useAlertUiTranslation();
    if (data.phin) {
        return (React.createElement(CollapsableSection, { title: t('phin.common.phinDetails'), header: null },
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    backgroundColor: themeColors.surface.secondary,
                } },
                React.createElement(DataBox, { label: t('phin.common.uniqueIdentifier'), value: data.phin.uniqueIdentifier }),
                React.createElement(DataBox, { label: t('phin.common.messageType'), enumKey: 'phin.enum.messageType', enumValue: data.phin.messageType }),
                React.createElement(DataBox, { label: t('phin.common.urgencyOfEvent'), enumKey: 'phin.enum.urgencyOfEvent', enumValue: data.phin.urgencyOfEvent }),
                React.createElement(DataBox, { label: t('phin.common.severityOfEvent'), enumKey: 'phin.enum.severityOfEvent', enumValue: data.phin.severityOfEvent }),
                React.createElement(DataBox, { label: t('phin.common.certaintyOfEvent'), enumKey: 'phin.enum.certaintyOfEvent', enumValue: data.phin.certaintyOfEvent }),
                React.createElement(DataBox, { label: t('phin.common.acknowledgeMessage'), value: data.phin.recipientAcknowledge != null
                        ? data.phin.recipientAcknowledge
                            ? t('common.yes')
                            : t('common.no')
                        : undefined }),
                React.createElement(DataBox, { label: t('phin.common.deliveryTime'), value: data.phin.deliveryTimeInMinutes != null
                        ? getDeliveryTimeInMinutesLabel(data.phin.deliveryTimeInMinutes)
                        : undefined }))));
    }
    else {
        return null;
    }
};
const DataBox = ({ label, value, enumKey, enumValue, }) => {
    const { t } = useAlertUiTranslation();
    if (value != null || enumValue != null) {
        let text = value !== null && value !== void 0 ? value : '';
        if (enumValue != null) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            text = t(`${enumKey}.${enumValue}`);
        }
        return (React.createElement(Box, { sx: {
                display: 'grid',
                gridTemplateColumns: { xs: '50% 50%', xl: '30% 70%' },
                p: 2,
                backgroundColor: themeColors.surface.tertiary,
                borderRadius: 1,
            } },
            React.createElement(Typography, { variant: 'body2' }, label),
            React.createElement(Typography, { variant: 'subtitle2' }, text)));
    }
    else {
        return null;
    }
};
